import { OrderState, OrderResponseProps } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getOrder } from './order.services';

export const initialState: OrderState = {
    data: {} as OrderResponseProps,
    status: "loading",
    error: {}
}

export const OrderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getOrder.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getOrder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getOrder.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const OrderReducer = OrderSlice.reducer